import { render } from "./CodingPractise.vue?vue&type=template&id=00a38594&scoped=true"
import script from "./CodingPractise.vue?vue&type=script&lang=js"
export * from "./CodingPractise.vue?vue&type=script&lang=js"

import "./CodingPractise.vue?vue&type=style&index=0&id=00a38594&lang=css"
import "./CodingPractise.vue?vue&type=style&index=1&id=00a38594&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a38594"]])

export default __exports__